module.exports = __webpack_public_path__ + "assets/img_thrive-market.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_thrive-market.jpg
 ** module id = 136
 ** module chunks = 1
 **/